import { Link } from "@mui/material";

export const Button = ({ label, href, primary, outlined, style, target, download, ...props }) => {
    const mode = [primary ? "storybook-button--primary" : "storybook-button--secondary", outlined && "storybook-button--outline"]
        .filter(Boolean)
        .join(" ");

    return (
        <Link
            href={href}
            target={target}
            rel={target === "_blank" ? "noopener noreferrer" : undefined}
            download={download}
            className={["vitaleau-button", mode].join(" ")}
            style={style}
            {...props}
        >
            {label}
        </Link>
    );
};
